const FEATURE_HELP_URLS = {
  agent_bots: 'https://lumeratec.com/ajuda/hc/agent-bots',
  agents: 'https://lumeratec.com/ajuda/hc/agents',
  audit_logs: 'https://lumeratec.com/ajuda/hc/audit-logs',
  campaigns: 'https://lumeratec.com/ajuda/hc/campaigns',
  canned_responses: 'https://lumeratec.com/ajuda/hc/canned',
  channel_email: 'https://lumeratec.com/ajuda/hc/email',
  channel_facebook: 'https://lumeratec.com/ajuda/hc/fb',
  custom_attributes: 'https://lumeratec.com/ajuda/hc/custom-attributes',
  dashboard_apps: 'https://lumeratec.com/ajuda/hc/dashboard-apps',
  help_center: 'https://lumeratec.com/ajuda/hc/help-center',
  inboxes: 'https://lumeratec.com/ajuda/hc/inboxes',
  integrations: 'https://lumeratec.com/ajuda/hc/integrations',
  labels: 'https://lumeratec.com/ajuda/hc/labels',
  macros: 'https://lumeratec.com/ajuda/hc/macros',
  reports: 'https://lumeratec.com/ajuda/hc/reports',
  sla: 'https://lumeratec.com/ajuda/hc/sla',
  team_management: 'https://lumeratec.com/ajuda/hc/teams',
  webhook: 'https://lumeratec.com/ajuda/hc/webhooks',
  billing: 'https://lumeratec.com/ajuda/pricing',
  saml: 'https://lumeratec.com/ajuda/hc/saml',
  lumerai_billing: 'https://lumeratec.com/ajuda/hc/lumerai_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
